import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/cartorio/';

class CartorioService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllEmolumentoByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'allEmolumentos?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllEmolumentoByFiltroVigente(idCliente, filtro) {
        return axios.get(API_URL + 'allEmolumentosVigente?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllTiposEmolumentoByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'allTipoEmolumentos?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllTiposEmolumentoByFiltroVigente(idCliente, filtro) {
        return axios.get(API_URL + 'allTipoEmolumentosVigente?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
    }

    save(emolumento) {
        return axios.post(API_URL + 'salvarEmolumento', JSON.stringify(emolumento),
            { headers: this.headers });
    }


    saveTipoEmolumento(tipoEmolumento) {
        return axios.post(API_URL + 'salvarTipoEmolumento', JSON.stringify(tipoEmolumento),
            { headers: this.headers });
    }

    getEmolumento(emolumentoId) {
        return axios.get(API_URL + 'emolumento/' + emolumentoId, { headers: this.headers });
    }

    ativarEmolumento(emolumentoId) {
        return axios.post(API_URL + 'ativarEmolumento/' + emolumentoId, null, { headers: this.headers });
    }

    inativarEmolumento(emolumentoId, dataInativacao) {
        return axios.post(API_URL + 'inativarEmolumento/' + emolumentoId+'/'+dataInativacao, null, { headers: this.headers });
    }

    ativarTipoEmolumento(emolumentoTipoId) {
        return axios.post(API_URL + 'ativarEmolumentoTipo/' + emolumentoTipoId, null, { headers: this.headers });
    }

    inativarTipoEmolumento(emolumentoTipoId) {
        return axios.post(API_URL + 'inativarEmolumentoTipo/' + emolumentoTipoId, null, { headers: this.headers });
    }

    findAllTipoByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'allTipoByFiltro?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllOrigemByFiltro(filtro) {
        return axios.get(API_URL + 'allOrigemByFiltro?filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllEmolumentosByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'allEmolumentosByFiltro?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }



}

export default new CartorioService();